import { Component, OnInit } from '@angular/core';
import { ProgramTypesGUID } from '../../../models/_enum-collections';
import { PendingReviewCountModel } from '../../../models/event-count-model';
import { CommonSharedModule } from '../../common/shared.module';
import { EventDashboardService } from '../../services/event-dashboard.service';

@Component({
  selector: 'app-mrpp-count',
  templateUrl: './mrpp-count.component.html',
  styleUrls: ['./mrpp-count.component.scss'],
  standalone: true,
  imports: [CommonSharedModule]
})
export class MrppCountComponent implements OnInit {
  constructor(private eventDashboardService: EventDashboardService) {}

  loading!: boolean;
  engagementCountModel!: PendingReviewCountModel;
  queueTitle = 'Pending Approval';

  ngOnInit() {
    this.loading = true;
    this.eventDashboardService
      .getPendingReviewQueues(ProgramTypesGUID.MRPP)
      .subscribe(data => {
        this.engagementCountModel = data;
        this.loading = false;
      });
  }
}
